let url = "";

if (location.hostname == "localhost") {
  url = "http://localhost:5057";
} else {
  url = window.ApiPath ? window.ApiPath : "https://yrfapi.gokozo.com";
}
url = "https://api.yrf.in";
// console.log("location.hostname", url, " window.ApiPath", window.ApiPath);
// url = "https://yrfapi.gokozo.com";
export const BASEURL = url;
